import ReactDOM from 'react-dom'
import React, { useEffect, useState } from 'react'

export const Portal = ({
  children,
  className = 'root-portal',
  el = 'div',
}: any) => {
  const [container] = useState(document.createElement(el))

  container.classList.add(className)

  useEffect(() => {
    document.body.appendChild(container)
    return () => {
      document.body.removeChild(container)
    }
  }, [])

  return ReactDOM.createPortal(children, container)
}
